import axios from "axios";
import urls from "../../urls";
import { getFirebaseIDToken } from "../firebase/firebase";

/**
 * Reset MFA for a specific user
 * @param {string} userId - The ID of the user whose MFA should be reset
 * @returns {Promise<Object>} Response from the API
 */
export const resetUserMfa = async (userId) => {
  try {
    const token = await getFirebaseIDToken();
    const response = await axios.post(
      `${urls.resetUserMfa}/${userId}`,
      {},
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error resetting MFA:", error);
    throw error;
  }
};

/**
 * Check MFA status for a specific user
 * @param {string} userId - The ID of the user whose MFA status should be checked
 * @returns {Promise<Object>} MFA status information
 */
export const checkMfaStatus = async (userId) => {
  try {
    const token = await getFirebaseIDToken();
    const response = await axios.get(`${urls.checkMfaStatus}/${userId}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error checking MFA status:", error);
    throw error;
  }
};
